"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
var highlight_1 = require("./highlight");
Object.defineProperty(exports, "Highlight", { enumerable: true, get: function () { return highlight_1.Highlight; } });
//# sourceMappingURL=index.js.map